/**
 * Represents a standardized User entity.
 * Formats the raw API user data into a clean structure for the UI.
 */
export const createUserModel = (data) => {
  if (!data) return null;

  // The API uses 'user' in registration and 'userProfile' in login
  const userData = data.user || data.userProfile || data;

  return {
    id: userData._id || userData.id,
    fullName: userData.fullName || '',
    email: userData.email || '',
    role: userData.role || 'customer',
    token: data.token || null, // Token is sometimes at the root of the data object
  };
};

